import React, {Component} from 'react';
import {View, TouchableOpacity, I18nManager, ActivityIndicator, Image, Platform, Alert} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import * as NavigationService from '../../../../../redux/NavigationService';
import HMTextView from "../../../../../customviews/HMTextView";
import  Colors from "../../../../../tools/Colors";
import connect from "react-redux/es/connect/connect";
import HMImageView from "../../../../../customviews/HMImageView";
import PathFile from "../../../../../assets/PathFile";


class AdapterListMyApply extends Component {

    componentWillMount() {

    }

    constructor(props) {
        super(props);
    }

    state = {
        indexLoading: -1
    }

    componentWillReceiveProps(propss) {

    }

    componentWillUnmount() {

    }

    render() {
        let {item, index, navigation, item_parent, hiddenModal} = this.props;
        // let fileImage = item.image || item.image === null ? item.image : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'image/jpeg')))
        // let fileVideo = item.video || item.video === null ? item.video : (item.files && item.files.length > 0 && (item.files.find(k => k.type === 'video/mp4')))
        //
        return (


            <TouchableOpacity style={{
                width: "98%",
                alignSelf: "center",
                paddingHorizontal: moderateScale(4),
                marginHorizontal: moderateScale(8)
            }}
                              onPress={() => {
                                  //  this.props.callServiceShowWebView("")
                                  NavigationService.navigateParams("DetailsDeadScreen", {item: item})
                                  hiddenModal()
                              }}
                //onPress={() =>NavigationService.navigateParams("VideoScreen", {id: item.id}) }

            >
                <View style={{
                    padding: moderateScale(8),
                    // flexDirection: "row",
                    // width: "100%",
                    flex: 1,
                    marginVertical: moderateScale(4),
                    borderRadius: moderateScale(5),
                    backgroundColor: Colors.backgroundColor,

                    // justifyContent: "flex-end"
                }}>

                    <View style={{flex: 1, flexDirection: 'row',}}>
                        <View style={{flexDirection: 'row', flex: .98, alignItems: 'center'}}>
                            <View style={{
                                height: moderateScale(48),
                                //   backgroundColor: '#d6ee19',
                                width: moderateScale(48),
                                borderRadius: moderateScale(24),
                                borderWidth: moderateScale(1),
                                borderColor: Colors.colorSecondPrimary,
                                backgroundColor: Colors.blackLight,
                                padding:!item.image || item.image == null || item.image == "null"? moderateScale(6):0
                            }}>
                                {
                                    !item.image || item.image == null || item.image == "null" ?
                                        <HMImageView
                                            resizeMode={"contain"}
                                            source_image={ PathFile.image.rose }
                                            styleText={{}} borderRadius={4}/>
                                        :

                                        <HMImageView
                                            resizeMode={"stretch"}
                                            uriComplete={item.image}

                                            // styleImage={{    height: moderateScale(48), width: moderateScale(48), borderRadius: moderateScale(24),}}
                                            // styleRoot={{    height: moderateScale(48), width: moderateScale(48), borderRadius: moderateScale(24),}}
                                            styleText={{}} borderRadius={24}/>
                                }

                            </View>

                            <View style={{width: moderateScale(6)}}/>
                            <View style={{}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(14),
                                        color: Colors.blackLight,
                                        //  textAlign: 'center',
                                        //alignSelf:'center',
                                        // marginTop: moderateScale(10)
                                    }}
                                    //  text={'1398/05/03'}
                                    // text={item.createdtime ? item.createdtime : item.date}
                                    text={item.name + " " + item.family}
                                />
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(11),
                                        color: Colors.colorDark,
                                        //   textAlign: 'center',
                                        //alignSelf:'center',
                                        // marginTop: moderateScale(10)
                                    }}
                                    //  text={'1398/05/03'}
                                    // text={item.createdtime ? item.createdtime : item.date}
                                    text={item.fader}
                                />
                            </View>
                        </View>
                        <View style={{
                            flex: .01, flexDirection: 'row',
                            alignItems: 'center', justifyContent: 'center'
                            //    backgroundColor:'#96ee5b'
                        }}>
                            <HMTextView
                                type={"bold"}
                                noFont={!I18nManager.isRTL}
                                style={{
                                    fontSize: moderateScale(13),
                                    color: Colors.colorDark,
                                    textAlign: 'center',
                                    //alignSelf:'center',
                                    // marginTop: moderateScale(10)
                                }}
                                //  text={'1398/05/03'}
                                // text={item.createdtime ? item.createdtime : item.date}
                                //     text={"رضا کریمی"}
                            />
                        </View>
                        <View style={{flexDirection: 'row', flex: .01, justifyContent: 'flex-end'}}>
                            {

                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: item.color ? item.color : Colors.gray,
                                                // marginTop: moderateScale(10)
                                            }}
                                    //   text={item.status}
                                    //   text={"98/03/21"}
                                />

                            }

                        </View>
                    </View>


                    <View style={{
                        flex: 1,
                        flexDirection: 'row',
                        marginTop: moderateScale(3),
                        paddingHorizontal: moderateScale(4)
                    }}>

                        <View style={{flex: .5}}>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"تولد: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                    //   text={item.status}
                                            text={item.birth}
                                />

                            </View>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"قطعه: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                            text={item.nugheteh}
                                    //text={"۵"}
                                />

                            </View>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"ردیف: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                            text={item.nuradif}
                                    //    text={"۱۳"}
                                />

                            </View>

                        </View>
                        <View style={{flex: .5}}>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"وفات: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                            text={item.date}
                                    //  text={"۱۳۹۸/۰۱/۰۱"}
                                />

                            </View>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"نوع قطعه: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                            text={item.typeghabr}
                                    //     text={"ویژه"}
                                />

                            </View>
                            <View style={{flex: 1, flexDirection: 'row'}}>
                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.blackLight,
                                    }}
                                    //   text={item.status}
                                    text={"شماره قبر: "}
                                />
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.gray,
                                            }}
                                            text={item.nughabr}
                                    //      text={"۴۰"}
                                />

                            </View>

                        </View>
                    </View>


                </View>
            </TouchableOpacity>


        );
    }

}

const mapStateToProps = state => {
    return {

        resultsSet: state.reducerMyApplyScreen.resultsSet,
        isLoadingSet: state.reducerMyApplyScreen.isLoadingSet,
        NoInternetDialogSet: state.reducerMyApplyScreen.NoInternetDialogSet,
        token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,
        id: state.reducerMyApplyScreen.id,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(url, params, type, typeConnection, page, item_count, id)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AdapterListMyApply);
